import styled from "styled-components";

export const AppHeaderCrossBrandTextDefaultBox = styled.div`
  /* this is overriden in mrgreen box */
  display: none;
`;
